import React from 'react'
import { Chip as ChipBase, Grid as GridBase, styled } from '@mui/material'
import { Card as CardBase } from '@chilecompra/react-kit/components'

export const Root = styled('div')`
  width: 100%;
`

export const GridContainer = styled(({ margin, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ margin, minHeight, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    min-height: ${props => props.minHeight};
    padding: ${props => props.padding};
  }
`

export const Card = styled(CardBase)`
  &.MuiPaper-root {
    cursor: ${props => (props.onClick ? 'pointer' : 'initial')};

    & > * {
      display: grid;
      grid-template-rows: ${props => (props.rows === 1 ? 'auto' : 'auto 18px')};
      height: 100%;
      padding: 16px;
      text-align: center;
    }
  }
`

export const Label = styled('div')`
  color: ${props => props.theme.palette.brand.primary};
`

export const Chip = styled(ChipBase)`
  color: ${props => props.theme.palette.red[50]};
  background-color: ${props => props.theme.palette.red[90]};
  border-radius: 4px;
  font-size: 12px;
  letter-spacing: 1.12px;
  padding: 8px 4px;
  text-transform: uppercase;
`

export const Strong = styled('strong')`
  font-size: 20px;
  margin-right: 5px;
`

export const Link = styled('a')``
